export default __webpack_public_path__ + "static/media/lausanne.d5aeded8.jpg";